<template>
  <div class="container">
    <h3>借用信息</h3>
    <el-form
      label-position="left"
      :rules="rules"
      label-width="80px"
      :model="formLabelAlign"
      ref="formLabelAlign"
    >
      <el-form-item label="借用人" prop="usedUserName">
        <el-autocomplete
          prop="usedUserName"
          class="inline-input"
          v-model="formLabelAlign.usedUserName"
          :fetch-suggestions="querySearch"
          placeholder="请输入内容"
          @select="handleSelect"
        ></el-autocomplete>
      </el-form-item>
      <el-form-item label="借用时间" required> 
        <el-col :span="4">
          <el-form-item>
            <el-date-picker
              v-model="usedDate"
              type="date"
              placeholder="选择日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input type="textarea" v-model="formLabelAlign.remark" style="width:30%;"></el-input>
      </el-form-item>
      <el-form-item label="文件上传">
        <el-upload
          action="/api/upload/singlefile/seal"
          :on-preview="handlePreview"
          :file-list="fileList"
          :headers="headers"
          :on-success="onSuccess"
          :on-remove="handleRemove">
          <el-button slot="trigger" size="small" type="primary">附件上传</el-button>
          <div slot="tip" class="el-upload__tip" style="color:red;">如果是多个附件,请打包上传</div>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submitForm('formLabelAlign')">借用</el-button>
        <el-button @click="resetForm('formLabelAlign')">重置</el-button>
      </el-form-item> 
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      fileList: [],
      headers: {"Authorization": localStorage.token},
      usedDate: "",
      restaurants: [],
      formLabelAlign: {
        usedUserName: "",
        remark: ""
      },
      rules: {
        usedUserName: [
          { required: true, message: "请选择借用人", trigger: "change" }
        ],
        remark: [{ required: true, message: "请填写备注", trigger: "blur" }]
      },
      url:''
    };
  },
  methods: {
    onSuccess(response, file, fileList){
      let matter = {'name':file.name,'url':response.data};
      this.fileList.push(matter);
      this.url = JSON.stringify(this.fileList);
      console.log(this.url)
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      let fileli = this.fileList;
      let url = file.url;
      let cnt = fileli.length;
      for(let i=0;i<cnt;i++){
        if(url == fileli[i].url){
          this.fileList.splice(i, 1);
          break
        }
      }
      this.url = JSON.stringify(this.fileList);
      console.log(this.url);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {
      console.log(file);
    },
    querySearch(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      cb(results);
    },
    createFilter(queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    loadAll() {
      return this.tableData;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if(this.usedDate == ''){
            this.$message({
                message: '请填写借用时间',
                type: 'warning'
            });
            return;
          }
          this.borrow(); // 新增 - 借用
        } else {
          return false; 
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    borrow() {
      this.$axios({
        url: '/api/seal',
        method: 'POST',
        data: {
            "remark": this.formLabelAlign.remark,
            "usedTime": this.usedDate,
            "usedUserName": this.formLabelAlign.usedUserName,
            'appendix':this.fileList[0].url
        }
      }).then(res => {
        if(res.status == 200){
            this.$message({
                message: '借用成功',
                type: 'success'
            });
            this.$router.push({path: "./chapterManagementLi"});
        }else{
            this.$message({
              message: '借用失败',
              type: 'warning'
            });
        }
      }).catch(err => {
          console.log(err);
      });
    },
    handleSelect(item) {
      // console.log(item);
    }
  },
  mounted() {
    console.log(localStorage.token);
    this.$axios({
      url: '/api/user/pcUsers',
      method: 'GET'
    }).then(res => {
      if(res.status == 200){
        let rData = res.data.data;
        let allName = [];
        for(let i=0;i<rData.length;i++){
          allName.push({
            value:rData[i].name,
            address:rData[i].name
          });
        }
        this.tableData = allName;
        this.restaurants = this.loadAll();
      }
    }).catch(err => {
        console.log(err);
    });
  }
};
</script>

<style type="text/css" scoped>
  .el-button--primary {
    color: #fff;
    background-color:  rgb(60, 110, 169);
    border-color: rgb(60, 110, 169);
  }
  .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
    color: #fff;
    background-color: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
  }
  .el-button--primary:focus, .el-button--primary:hover {
    background: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
    color: #fff;
  }
.container {
  padding: 25px;
}

.container h3 {
  font-weight: normal;
  font-size: 16px;
  color: #95b2d4;
  padding: 10px 0px;
  margin-bottom: 15px;
}

.container h4 {
  font-weight: normal;
  font-size: 16px;
  color: red;
  padding: 10px 0px;
  margin-top: 20px;
  margin-bottom: 15px;
}

.drugs {
  width: 100%;
  height: auto;
}

.operation {
  margin-top: 30px;
  float: right;
}

.preserve {
  margin-right: 30px;
}
</style>



// WEBPACK FOOTER //
// increase.vue?18b10772